import { render, staticRenderFns } from "./HomeWishlistBR.vue?vue&type=template&id=1b7f8d2c&scoped=true"
import script from "./HomeWishlistBR.vue?vue&type=script&lang=js"
export * from "./HomeWishlistBR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f8d2c",
  null
  
)

export default component.exports